import { GLOBAL_VALUES } from 'eebac/constants';
const BASE_PATH = 'PROFILE_ADDRESS';

export const SET_ADDRESS_DATA = `${BASE_PATH}/SET_ADDRESS_DATA`;
export const CLEAR_ADDRESS_DATA = `${BASE_PATH}/CLEAR_ADDRESS_DATA`;
export const VALIDATE_ADDRESS_DATA = `${BASE_PATH}/VALIDATE_ADDRESS_DATA`;


export const setProfileAddressData = data => ({
    type: SET_ADDRESS_DATA,
    data
});

export const clearProfileAddressData = data => ({
    type: CLEAR_ADDRESS_DATA,
    data
});

export const validateAddressInfoData = () => ({
    type: VALIDATE_ADDRESS_DATA,
});

const initialState = {
    state: GLOBAL_VALUES.DEFAULT_ADDRESS_STATE,
    city: '',
    pincode: '',

    stateError: '',
    cityError: '',
    pincodeError: '',

    validate: false,
    isValid: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_ADDRESS_DATA:
            let newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case CLEAR_ADDRESS_DATA:
            return { ...initialState }
        case VALIDATE_ADDRESS_DATA:
            return { ...state, validate: true }
    }

    return state;
}